export default {
  setLots (state, lots) {
    state.lots = lots
  }
}
